import { css } from 'styled-components';
import { ColorAddiPrimaryActive, ColorAddiPrimaryInactive, ColorAddiPrimaryHover } from "@addi/foundation/dist/web/colors";
export const TertiaryButtonStyles = css `
    border: none;
    color: ${ColorAddiPrimaryActive};
    background-color: transparent;

    &:hover, &:focus {
        color: ${ColorAddiPrimaryHover};

        svg {
            color: ${ColorAddiPrimaryHover};
        }
    }

    &:active {
        color: ${ColorAddiPrimaryHover};

        svg {
            color: ${ColorAddiPrimaryHover};
        }
    }


    &[disabled] {
        cursor: default;
        pointer-events: none;
        color: ${ColorAddiPrimaryInactive};
        border-color: ${ColorAddiPrimaryInactive};

        svg {
            color: ${ColorAddiPrimaryInactive};
        }
    }

    svg {
        color: ${ColorAddiPrimaryActive};
    }
`;
//# sourceMappingURL=tertiary-button-styles.js.map